<template>
  <div :class="{ 'mr-2': !last }" class="flex-1 overflow-hidden rounded-lg">
    <!-- Title -->
    <div
      v-text="title"
      :class="[
        'text-white bg-primary font-semibold text-center truncate uppercase rounded-t',
        compressed ? 'py-1 text-xs' : 'py-1 text-sm',
      ]"
    ></div>

    <!-- Value -->
    <div
      class="text-center font-bold text-primary bg-primary-light flex items-center justify-center rounded-b-lg py-2"
      :class="[
        'papsi-countdown-h',
        compressed ? 'text-lg' : 'text-xl',
      ]"
    >
      <div v-text="value" class="leading-none"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-countdown-item",
  props: {
    title: {
      type: String,
    },
    value: {
      type: String,
      default: "00",
    },
    compressed: {
      type: Boolean,
      default: false,
    },
    last: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.papsi-countdown-h {
  height: auto;
  padding: 6px 0;
}

.papsi-countdown-h.compressed {
  height: auto;
  padding: 4px 0;
}

.papsi-hithere {
  animation: hithere 1s ease infinite;
}

@keyframes hithere {
  30% {
    transform: scale(1.2);
  }

  40%,
  60% {
    transform: rotate(-20deg) scale(1.2);
  }

  50% {
    transform: rotate(20deg) scale(1.2);
  }

  70% {
    transform: rotate(0deg) scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}
</style>
